module.exports = __webpack_public_path__ + "img/ico_recommend_tour.ef9e374c.png";